import Vue from 'vue'

import axios from './axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import Toasted from 'vue-toasted'
import VTooltip from 'v-tooltip'
import Rollbar from 'vue-rollbar'
import hotjar from './hotjar'

Vue.use(VueAxios, axios)

Vue.use(VueMeta)

Vue.use(Toasted, {
  duration: 5000,
  position: 'bottom-right'
})

Vue.use(VTooltip)

Vue.use(Rollbar, {
  enabled: process.env.VUE_APP_ENV === 'production',
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.VUE_APP_ENV
  }
})

Vue.use(hotjar)

Vue.config.productionTip = false

export default Vue
